const createJoinApi = ({ origin, prefixPath, }) => ({ version, path, }) => {
    const baseUrl = new URL(origin);
    const basePath = baseUrl.pathname.replace(/\/$/, '');
    const fullPath = `${basePath}${prefixPath}${version ? `/${version}` : ''}${path}`;
    return new URL(fullPath, origin);
};

export { createJoinApi };
//# sourceMappingURL=index.js.map
